
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.603 10.73h-.72V7.256c0-.022-.004-.043-.006-.066a.577.577 0 00-.14-.38L19.952.2l-.004-.004A.577.577 0 0019.83.1a.618.618 0 00-.155-.072l-.032-.01A.584.584 0 0019.51 0H5.293c-.649 0-1.176.528-1.176 1.176v9.555h-.72c-.93 0-1.682.752-1.682 1.681v8.744c0 .928.753 1.682 1.681 1.682h.72v5.986c0 .648.528 1.176 1.177 1.176h19.412c.648 0 1.176-.528 1.176-1.176v-5.986h.72c.929 0 1.682-.753 1.682-1.682v-8.744a1.68 1.68 0 00-1.681-1.681zM5.294 1.177h13.627v6.02c0 .325.264.588.588.588h5.197v2.947H5.294V1.176zm11.918 16.04c-1.156-.402-1.91-1.041-1.91-2.053 0-1.188.991-2.096 2.633-2.096.784 0 1.362.165 1.775.351l-.35 1.27a3.312 3.312 0 00-1.456-.33c-.681 0-1.012.309-1.012.67 0 .444.393.64 1.29.98 1.229.455 1.807 1.095 1.807 2.076 0 1.166-.898 2.157-2.808 2.157-.795 0-1.58-.206-1.972-.423l.32-1.3a4.02 4.02 0 001.745.433c.723 0 1.104-.3 1.104-.753 0-.434-.33-.682-1.166-.981zm-2.662 1.6v1.322h-4.347V13.18h1.58v5.637h2.767zm-9.394 1.322H3.36l2.013-3.52-1.94-3.438h1.806l.609 1.27c.206.423.361.763.526 1.156h.02c.166-.444.3-.754.475-1.156l.589-1.27h1.796l-1.962 3.396 2.065 3.562H7.541l-.63-1.26c-.258-.484-.423-.846-.62-1.249h-.02c-.145.403-.32.765-.537 1.25l-.578 1.26zm19.55 8.367H5.294v-5.667h19.412v5.667zm.01-8.367l-.63-1.26c-.257-.484-.422-.845-.619-1.248h-.02c-.145.403-.32.764-.537 1.249l-.578 1.26h-1.796l2.012-3.522-1.94-3.437h1.806l.61 1.27c.206.423.36.763.526 1.156h.02c.166-.444.3-.754.475-1.156l.588-1.27h1.797l-1.961 3.396 2.064 3.562h-1.817z","fill":"#1BA7E1"}})])
          )
        }
      }
    